'use client';

import type { IconProps } from '@iconify/react';

import { Icon } from '@iconify/react';

import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

/**
 * DynamicIcon - Wrapper za Iconify koji dozvoljava bilo koji string za ikonu.
 * Koristi se za ikone koje nisu registrirane u icon-sets.
 * Ikone se učitavaju online što može uzrokovati flickering.
 */
export type DynamicIconProps = React.ComponentProps<typeof IconRoot> &
  Omit<IconProps, 'icon'> & {
    icon: string;
  };

export function DynamicIcon({
  className,
  icon,
  width = 20,
  height,
  sx,
  ...other
}: DynamicIconProps) {
  return (
    <IconRoot
      ssr
      icon={icon}
      className={className}
      sx={[
        {
          width,
          flexShrink: 0,
          height: height ?? width,
          display: 'inline-flex',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}

// ----------------------------------------------------------------------

const IconRoot = styled(Icon)``;
